import { NOTIFICATION } from '@Constants/types';

const initialState = {
    fileSize: -1
};

export default function notificationReducer(state = initialState, action) {
    switch (action.type) {
        case NOTIFICATION.FILE_SIZE:
            return {
                ...state,
                fileSize: action.payload
            };

        default:
            return state;
    }
}
